import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const DownloadBatchDeliverableFinalFilesMutation = input =>
  new Promise((resolve, reject) => {
    commitMutation(getEnvironment(), {
      mutation: graphql`
        mutation DownloadBatchDeliverableFinalFilesMutation(
          $input: DownloadBatchDeliverableFinalFilesInput!
        ) {
          downloadBatchDeliverableFinalFiles(input: $input) {
            email
          }
        }
      `,
      variables: { input },
      onCompleted: resolve,
      onError: reject
    });
  });

export default DownloadBatchDeliverableFinalFilesMutation;
